const BASE_URL: string = 'https://databackedbetting-6c42029ec630.herokuapp.com/'

// type endpointType = "cappers/" | "bets/"
// type paramsType = string | URLSearchParams | string[][] | Record<string, string> | undefined | null
type dataType = BodyInit | null | undefined | object
type method = "GET" | "POST" | "PATCH" | "DELETE"

// type dataObjectType = {
//     data?: dataType,
//     params?: paramsType
// }

export default async function wrapper(endpoint: string, method: method, data?: dataType){

    const token = localStorage.getItem("dbbToken")
    const out = await fetch(BASE_URL + endpoint,
        {   
            "method": method,
            "body": JSON.stringify(data),
            "headers":{
                "Content-Type": "application/json",
                "Authorization": "Bearer " + token
            }
        }
    )
    
    if (out.ok) {
        return await out.json()
    } else {
        return "failed"
    }

}